import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { errMsg } from '../components/diagnostico/errMsg.js';
import MainLayout from '../components/Layout/MainLayout.js';
import { Button } from '../components/ui/button.jsx';
import { ArrowLeft, Download } from 'lucide-react';
import DiagnosticResultsView from '../components/diagnostico/DiagnosticResultsView.js';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });

const q = (v) => `"${String(v ?? '').replace(/"/g, '""')}"`;

const exportCSV = (data) => {
  const lines = [`Diagnóstico;${q(data.nome)}`, `Total de respostas;${data.total_responses}`, ''];
  (data.questions || []).forEach((item, idx) => {
    lines.push(`Pergunta ${idx + 1};${q(item.text)}`);
    if (item.type === 'open') {
      lines.push('Empresa;Resposta');
      (item.answers_open || []).forEach(a => lines.push(`${q(a.company_name || '')};${q(a.answer)}`));
    } else {
      lines.push('Opção;Contagem;Percentual');
      (item.distribution || []).forEach(d => lines.push(`${q(d.option)};${d.count};${d.percent}%`));
    }
    lines.push('');
  });
  const blob = new Blob(['\uFEFF' + lines.join('\n')], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `diagnostico-${(data.nome || '').replace(/[^a-z0-9]/gi, '_')}.csv`;
  a.click();
  URL.revokeObjectURL(url);
};

const DiagnosticoResultados = () => {
  const { diagnosticId } = useParams();
  const navigate = useNavigate();
  const userRole = localStorage.getItem('userRole') || 'respondent';
  const isAdmin = userRole === 'admin' || userRole === 'manager';
  const [data, setData] = useState(null);

  useEffect(() => {
    axios.get(`${API}/diagnostics/${diagnosticId}/results`, auth())
      .then(r => setData(r.data))
      .catch(err => {
        toast.error(errMsg(err, 'Sem permissão / não encontrado'));
        navigate('/diagnosticos');
      });
  }, [diagnosticId, navigate]);

  if (!data) return <MainLayout title="Resultados" userRole={userRole}><p className="text-sm text-slate-400 p-6">Carregando...</p></MainLayout>;

  return (
    <MainLayout title={`Resultados: ${data.nome}`} userRole={userRole}>
      <div className="flex flex-col gap-5" data-testid="results-page">
        <div className="flex items-center justify-between flex-wrap gap-2">
          <Button variant="outline" size="sm" onClick={() => navigate('/diagnosticos')} data-testid="back-btn">
            <ArrowLeft className="w-4 h-4 mr-1" /> Voltar
          </Button>
          <Button variant="outline" size="sm" onClick={() => exportCSV(data)} data-testid="export-csv">
            <Download className="w-4 h-4 mr-1" /> Exportar CSV
          </Button>
        </div>
        <DiagnosticResultsView data={data} isAdmin={isAdmin} />
      </div>
    </MainLayout>
  );
};

export default DiagnosticoResultados;
